import { SocialPlatform } from '~/types';
import { useQuery } from '~/utils/rq';

type SocialPlatforms = SocialPlatform[];

type SocialPlatformsResponse = {
  items: SocialPlatforms;
};

type FetchSocialPlatformsProps = {
  isEnabled: boolean;
};

const URL = '/admin/social-platforms';

export const useFetchSocialPlatforms = ({
  isEnabled
}: FetchSocialPlatformsProps) =>
  useQuery<SocialPlatformsResponse>(
    {
      queryKey: [URL],
      staleTime: 10 * 60 * 60,
      enabled: isEnabled
    },
    {
      method: 'get',
      url: URL
    }
  );
